import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout as DashboardLayout } from 'src/layouts/setting';

const CallLogsPage = lazy(() => import('src/pages/promaxLive/callLogs'));
const ChatActivityPage = lazy(() => import('src/pages/promaxLive/chatActivity'));
const LiveUsersPage = lazy(() => import('src/pages/promaxLive/liveUsers'));
const DevicesPage = lazy(() => import('src/pages/promaxLive/devices'));
const MediaUsagePage = lazy(() => import('src/pages/promaxLive/mediaUsage'));
const BlockedUsersPage = lazy(() => import('src/pages/promaxLive/blockedUsers'));
const UserContactsPage = lazy(() => import('src/pages/promaxLive/userContacts'));

export const promaxLiveRoutes = [
  {
    path: 'promaxLive',
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <DashboardLayout>
          <Outlet />
        </DashboardLayout>
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: <CallLogsPage />,
      },
      {
        path: 'callLogs',
        element: <CallLogsPage />,
      },
      {
        path: 'chatActivity',
        element: <ChatActivityPage />,
      },
      {
        path: 'liveUsers',
        element: <LiveUsersPage />,
      },
      {
        path: 'devices',
        element: <DevicesPage />,
      },
      {
        path: 'mediaUsage',
        element: <MediaUsagePage />,
      },
      {
        path: 'blockedUsers',
        element: <BlockedUsersPage />,
      },
      {
        path: 'userContacts',
        element: <UserContactsPage />,
      },
    ],
  },
];
